export const Category = {
  Reservation: 'reservation',
  GuestRoom: 'guestRoom',
  Sales: 'sales',
  Checkin: 'checkin',
} as const
export type Category = (typeof Category)[keyof typeof Category]

export type Column = {
  value: string
  label: string
  category: Category
  isDefault: boolean
}
export interface Setting {
  id: string
  title: string
  columns: Array<Column>
}
